import styled from "styled-components";
import { DescriptionStyles } from "../../types/styles";

const StyledDescription = styled.p<{
  styles: DescriptionStyles;
}>`
  line-height: 20px;
  color: ${({ styles }) => styles.OverallGeneralTextColour};
  margin: 0;
  font-size: 13px;
`;

export type DescriptionProps = {
  children: string;
  styles: DescriptionStyles;
  dataId?: string;
};

export const Description: React.FC<DescriptionProps> = ({
  children,
  styles,
  dataId,
}) => {
  return (
    <StyledDescription styles={styles} data-id={dataId}>
      {children}
    </StyledDescription>
  );
};

export default Description;
